// extracted by mini-css-extract-plugin
module.exports = {"NavigationItem":"navigation_item_NavigationItem__1CpYm","Active":"navigation_item_Active__21AUI"};